/* ============================================================
   WORDS — トップページ（リデザイン v5 / 2026-09）
   対応マークアップ：sections/main-index.liquid
   ・外部ライブラリは使いません（素のJS）
   内容
     1. ヒーロー動画：2本を交互に再生
     2. Instagram：Behold などの公開フィードJSONから表示（6時間キャッシュ）
     3. 形から探す：5分類のアコーディオン（スマホ・開いている分類は1つだけ・初期は全部閉じる）
     4. 新着：5分類タブの切り替え（パネルの hidden 切替＋右上リンクの文言・リンク先を連動）
     5. セクションの登場アニメーション（IntersectionObserver・0.35秒／一度出たら監視をやめる）
   ============================================================ */
(function () {
  'use strict';

  /* --- 1. ヒーロー動画：2本を交互に再生 ---------------------------
     ・2本目は再生の直前まで読み込まないので、最初の表示速度に影響しません。
     ・2本目が無い／再生に失敗したときは1本目をループします。
     ・「動きを減らす」設定（prefers-reduced-motion: reduce）の端末では
       自動再生せず、静止画（video の poster。無ければ1フレーム目）を出します。
     ・再生／停止ボタンは指示により削除しました（関連CSSも削除済み）。 */
  /* --- 1-B. ヒーロー動画：ブロックで登録した動画を順番に流す（2026-09-26） ---
     ・PC（768px以上）は data-hv-pc、スマホは data-hv-sp の動画を登録順に1本ずつ流す
       （片方が空なら、もう片方を使う）
     ・2つの video を交互に使い、次の動画は終わる3秒前から読み込んで、切り替えはふわっと重ねる
     ・1本だけならループ。読み込めない動画は飛ばす
     ・「動きを減らす」設定の端末では自動再生しない（最初の動画の1コマ目かポスターを出す） */
  var hvPlaylist = (function () {
    var media = document.querySelector('.wi-hero__media[data-hv-list]');
    if (!media) return false;
    var A = document.getElementById('hv1');
    var B = document.getElementById('hv2');
    if (!A || !B) return true;

    var reduce = false;
    try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
    var mq = window.matchMedia ? window.matchMedia('(min-width: 768px)') : { matches: true };

    /* 並びをそろえたまま空の要素だけ除く（動画と静止画の順番がずれないように） */
    function list(attr) { var a = (media.getAttribute(attr) || '').split('|'); a.pop(); return a; }
    function pick() {
      var pc = list('data-hv-pc'), sp = list('data-hv-sp');
      var usePc = mq.matches ? pc.length > 0 : sp.length === 0;
      return usePc ? { v: pc, p: list('data-hv-pc-po') } : { v: sp, p: list('data-hv-sp-po') };
    }

    var picked = pick(), items = picked.v, posters = picked.p, idx = 0, cur = A, nxt = B, preFor = -1, fails = 0;
    if (!items.length) return true;

    function setPoster(v, i) { var p = posters[i]; if (p) v.setAttribute('poster', p); }
    function setSrc(v, u) { if (v.getAttribute('src') !== u) { v.setAttribute('src', u); } }
    function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

    function start() {
      idx = 0; preFor = -1; fails = 0;
      cur = A; nxt = B;
      A.classList.add('is-on'); B.classList.remove('is-on');
      B.pause();
      setPoster(A, 0);
      setSrc(A, items[0]);
      if (reduce) { A.preload = 'metadata'; A.pause(); return; }
      A.loop = items.length === 1;
      A.preload = 'auto';
      tryPlay(A);
    }

    function prep() {
      var n = (idx + 1) % items.length;
      preFor = n;
      setPoster(nxt, n);
      setSrc(nxt, items[n]);
      nxt.preload = 'auto';
      try { nxt.load(); } catch (e) {}
    }

    function advance() {
      if (items.length < 2) return;
      idx = (idx + 1) % items.length;
      if (preFor !== idx) { setPoster(nxt, idx); setSrc(nxt, items[idx]); }
      preFor = -1;
      try { nxt.currentTime = 0; } catch (e) {}
      tryPlay(nxt);
      nxt.classList.add('is-on');
      nxt.removeAttribute('aria-hidden');
      cur.classList.remove('is-on');
      cur.setAttribute('aria-hidden', 'true');
      var old = cur; cur = nxt; nxt = old;
      setTimeout(function () { if (nxt !== cur) nxt.pause(); }, 900);
    }

    [A, B].forEach(function (v) {
      v.addEventListener('timeupdate', function () {
        if (v !== cur || items.length < 2 || preFor !== -1) return;
        if (v.duration && v.duration - v.currentTime < 3) prep();
      });
      v.addEventListener('ended', function () { if (v === cur) advance(); });
      v.addEventListener('playing', function () { if (v === cur) fails = 0; });
      v.addEventListener('error', function () {
        if (v !== cur || reduce) return;
        fails += 1;
        if (fails < items.length) advance();
      });
    });

    /* PCとスマホの境目をまたいで画面幅が変わったら、その幅の動画に入れ替える */
    function onChange() {
      var n = pick();
      if (n.v.join('|') !== items.join('|')) { items = n.v; posters = n.p; if (items.length && started) start(); }
    }
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    /* 先に静止画だけ出しておき、動画はページの読み込みが終わってから流す（表示速度を優先） */
    setPoster(A, 0);
    var started = false;
    function go() { if (started) return; started = true; start(); }
    function later() { if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 300); }
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later);
    return true;
  })();

  (function () {
    if (hvPlaylist) return;
    var v1 = document.getElementById('hv1');
    var v2 = document.getElementById('hv2');
    if (!v1) return;

    var reduce = false;
    try {
      reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {}

    if (reduce) {
      // autoplay 属性で走り出した分を止め、静止画に戻す（2本目も読み込まない）
      v1.removeAttribute('autoplay');
      v1.pause();
      try { v1.currentTime = 0; } catch (e) {}
      // ポスター画像があるときだけ読み込みを捨てて静止画に戻す。
      // ポスターが無いときは動画の1フレーム目をそのまま見せたいので触らない。
      if (v1.getAttribute('poster')) { v1.preload = 'none'; v1.load(); }
      return;
    }

    if (!v2) { v1.loop = true; return; }

    var preloaded = false;
    v1.addEventListener('timeupdate', function () {
      // 終わる3秒前に2本目の読み込みを開始（待ち時間ゼロで切替）
      if (!preloaded && v1.duration && v1.duration - v1.currentTime < 3) {
        preloaded = true;
        v2.preload = 'auto';
        v2.load();
      }
    });

    v1.addEventListener('ended', function () {
      var p = v2.play();
      v2.classList.add('show');
      if (p && p.catch) {
        p.catch(function () {
          // 2本目が再生できない環境では1本目のループに戻す
          v2.classList.remove('show');
          v1.loop = true;
          v1.currentTime = 0;
          v1.play();
        });
      }
    });

    v2.addEventListener('ended', function () {
      v2.classList.remove('show');
      v1.currentTime = 0;
      v1.play();
    });
  })();

  /* --- 2. Instagram（Behold / Meta Graph API のJSONフィード両対応） ---
     ★access_token は絶対にここへ書かないこと（公開ページのソースから見えます）。
       Behold（behold.so）などの「公開フィードJSON」のURLだけを指定します。 */
  (function () {
    var track = document.getElementById('t-ig');
    if (!track) return;

    /* 翻訳（2026-10-03）：snippets/words-t-index.liquid が出す window.WORDS_T.index_js を使う。無ければ日本語 */
    function T_index_js(k, ja) { var t = window.WORDS_T && window.WORDS_T.index_js; return (t && t[k]) || ja; }

    // 画像ガード：読み込み失敗・極端な横長／縦長は上品なプレースホルダーに置き換える
    function toPlaceholder(img) {
      var box = img.parentNode;
      if (!box || box.getAttribute('data-ph') === '1') return;
      box.setAttribute('data-ph', '1');
      box.innerHTML = '<span class="ig-ph"><svg viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5"></rect><circle cx="12" cy="12" r="4.4"></circle><circle cx="17.6" cy="6.4" r="1.1"></circle></svg><b>@words_official__</b></span>';
    }
    function guard(img) {
      function check() {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) { toPlaceholder(img); return; }
        var r = w / h;
        if (r > 1.7 || r < 0.6) toPlaceholder(img); // 横長バナー・極端な縦長を排除
      }
      img.addEventListener('error', function () { toPlaceholder(img); });
      if (img.complete) check(); else img.addEventListener('load', check);
    }
    function guardAll() {
      [].slice.call(track.querySelectorAll('.ig-photo img')).forEach(guard);
    }
    guardAll();

    var feedUrl = track.getAttribute('data-ig-feed');
    if (!feedUrl) return; // 未設定なら静的カードのまま

    function render(items) {
      if (!items || !items.length) return false;
      track.innerHTML = '';
      items.slice(0, 6).forEach(function (it) {
        var a = document.createElement('a');
        a.href = it.link;
        a.target = '_blank';
        a.rel = 'noopener';
        a.className = 'ig-post';
        var photo = document.createElement('div');
        photo.className = 'ig-photo';
        var img = document.createElement('img');
        img.src = it.img;
        img.alt = T_index_js('ig_post', 'Instagramの投稿');
        img.loading = 'lazy';
        img.decoding = 'async';
        photo.appendChild(img);
        if (it.video) {
          var play = document.createElement('span');
          play.className = 'ig-play play';
          play.innerHTML = '<svg viewBox="0 0 24 24"><polygon points="6 4 20 12 6 20"></polygon></svg>';
          photo.appendChild(play);
        }
        a.appendChild(photo);
        track.appendChild(a);
      });
      guardAll();
      return true;
    }

    /* 直前に取得できた投稿をブラウザに保存しておく
         目的①：Beholdの無料枠は「月間の表示回数」で止まるため、
                 ページを開くたびにAPIを叩かない（6時間はキャッシュを使う）＝消費を大幅に削減。
         目的②：APIが止まっている時も、少し前の投稿をそのまま表示できる。
                 ただしInstagramの画像URLは数日で期限切れになるので、
                 古すぎるキャッシュ（3日超）は使わず静的カードに戻す。 */
    var KEY = 'wordsIgFeed_v1';
    var FRESH = 6 * 60 * 60 * 1000;         // 6時間以内ならAPIを呼ばない
    var STALE_OK = 3 * 24 * 60 * 60 * 1000; // 3日以内なら「古いけど表示する」

    function loadCache() {
      try {
        var raw = window.localStorage ? localStorage.getItem(KEY) : null;
        if (!raw) return null;
        var c = JSON.parse(raw);
        if (!c || !c.t || !c.items || !c.items.length) return null;
        return c;
      } catch (e) { return null; }
    }
    function saveCache(items) {
      try {
        if (window.localStorage) localStorage.setItem(KEY, JSON.stringify({ t: (new Date()).getTime(), items: items }));
      } catch (e) { /* 保存できなくても表示には影響しない */ }
    }

    var cache = loadCache();
    var now = (new Date()).getTime();

    // キャッシュが新しい → APIを呼ばずにそのまま表示
    if (cache && (now - cache.t) < FRESH) { render(cache.items); return; }

    fetch(feedUrl).then(function (r) { return r.json(); }).then(function (json) {
      // Behold: {posts:[...]} または [...] ／ Graph API: {data:[...]}
      var posts = json.posts || json.data || (Array.isArray(json) ? json : []);
      var items = posts.map(function (p) {
        return {
          link: p.permalink || p.permalinkUrl || '',
          img: (p.sizes && p.sizes.medium && p.sizes.medium.mediaUrl) || (p.sizes && p.sizes.small && p.sizes.small.mediaUrl) || p.thumbnailUrl || p.thumbnail_url || p.mediaUrl || p.media_url || '',
          video: /VIDEO|REELS/i.test(p.mediaType || p.media_type || '')
        };
      }).filter(function (it) { return it.link && it.img; }).slice(0, 6);
      if (items.length) { saveCache(items); render(items); return; }
      throw new Error('empty');
    }).catch(function () {
      // 取得できなかった時：3日以内のキャッシュがあれば少し前の投稿を表示。
      // それも無ければ静的カード（実際のリール）のまま。
      if (cache && (now - cache.t) < STALE_OK) render(cache.items);
    });
  })();

})();

/* --- 3. 形から探す：5分類のアコーディオン（スマホ） -------------
   ・行（.wi-shp__btn）を押すと、その下の .wi-shp__panel（子カテゴリーのチップ）が開閉します。
   ・開いている分類は常に1つだけ（別の行を開くと、開いていた行は自動的に閉じます）。
   ・初期状態はすべて閉じています（管理画面でチェックした1つだけ Liquid 側が開いた状態で出します）。
   ・子カテゴリーが無い分類（XL）の行は button ではなくリンク（a.wi-shp__btn--link）なので対象外です。
   ・パソコン表示では CSS でパネルを常に表示しているので、押しても見た目は変わりません。 */
(function () {
  var btns = document.querySelectorAll('button.wi-shp__btn');
  if (!btns.length) return;

  function panelOf(btn) { return btn.parentNode.querySelector('.wi-shp__panel'); }

  function closeAll() {
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-expanded', 'false');
      btns[i].parentNode.classList.remove('is-open');
      var panel = panelOf(btns[i]);
      if (panel) panel.hidden = true;
    }
  }

  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener('click', function () {
      var btn = this;
      var wasOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (!wasOpen) {
        btn.setAttribute('aria-expanded', 'true');
        btn.parentNode.classList.add('is-open');
        var panel = panelOf(btn);
        if (panel) panel.hidden = false;
      }
    });
  }
})();

/* --- 4. 新着：5分類タブの切り替え ------------------------------
   ・タブ（.wi-new__tab[data-new-tab]）を押すと、同じ値の data-new-panel を持つ
     パネルだけを表示し、ほかは hidden にします（ページ遷移・再取得なし）。
   ・右上のリンク（[data-new-more]）の文言とリンク先も、押したタブの
     data-title / data-url に合わせて書き換えます（文言＝タブ名＋data-suffix）。 */
(function () {
  var tabs = document.querySelectorAll('.wi-new__tab[data-new-tab]');
  if (!tabs.length) return;
  var panels = document.querySelectorAll('.wi-new__panel[data-new-panel]');
  var more = document.querySelector('[data-new-more]');
  var suffix = more ? (more.getAttribute('data-suffix') || '') : '';

  function pick(tab) {
    var key = tab.getAttribute('data-new-tab');
    for (var j = 0; j < tabs.length; j++) {
      var on = tabs[j] === tab;
      tabs[j].classList.toggle('is-active', on);
      tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    for (var k = 0; k < panels.length; k++) {
      panels[k].hidden = panels[k].getAttribute('data-new-panel') !== key;
    }
    if (more) {
      more.textContent = (tab.getAttribute('data-title') || '') + suffix;
      var url = tab.getAttribute('data-url');
      if (url) more.setAttribute('href', url);
    }
  }

  for (var i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', function () { pick(this); });
  }

  /* 読み込み時：Liquid が is-active を付けたタブに合わせて右上リンクを整える */
  var first = document.querySelector('.wi-new__tab.is-active[data-new-tab]') || tabs[0];
  pick(first);
})();

/* --- 5. セクションの登場アニメーション -----------------------------
   ・対象は .wi-reveal（各セクションの大枠）。
   ・0.35秒でふわっと表示（CSS側は assets/words-index.css の .wi-reveal）。
   ・IntersectionObserver 非対応のブラウザでは、最初から通常表示にする
     （待たせない・見えなくならないことを優先）。
   ・prefers-reduced-motion: reduce のときは、CSS側で最初から opacity:1 に
     しているので、ここでは何もしなくても即表示になります。 */
(function () {
  var targets = document.querySelectorAll('.wi-reveal');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < targets.length; i++) { targets[i].classList.add('is-in'); }
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  for (var j = 0; j < targets.length; j++) { io.observe(targets[j]); }
})();
